import React, { useState, useEffect, FunctionComponent } from 'react';
import { PRODUCT_NAME } from '../branding/constants';

const LOADING_INDICATOR_DELAY_MS = 1000;

const LoadingIndicator: FunctionComponent = () => {
  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setShowLoading(true), LOADING_INDICATOR_DELAY_MS);
    return (): void => {
      clearTimeout(timeout);
    };
  }, [setShowLoading]);

  return showLoading ? <p>{PRODUCT_NAME} — Loading...</p> : null;
};

export default LoadingIndicator;
